import {
  DFData,
  DFErrors,
  DFormState,
  DFValues,
  DynamicForm
} from '@vmware-react/vrlcm';
import React, { FC } from 'react';
import { deepEquals } from 'vrlcm-gui-utils';
import { Schema } from 'yup';
import { l10n } from '../with-app-root/i18n/i18nUtil';

interface Props {
  debugInfo?: boolean;
  data: DFData;
  hideReqMsg?: boolean;
  onChangeValues?: (values: DFValues) => void;
  onChangeErrors?: (errors: DFErrors) => void;
  onChangeValidity?: (valid: boolean) => void;
  validationSchema?: Schema<{}>;
}

const DFWrapper: FC<Props> = props => {
  const {
    data,
    hideReqMsg = false,
    onChangeValues,
    onChangeErrors,
    onChangeValidity,
    validationSchema,
    debugInfo
  } = props;

  const onChangeFormState = (state: DFormState, prevState?: DFormState) => {
    const prevValues = prevState ? prevState.values : undefined;
    const { values, isValid, errors } = state;
    if (onChangeErrors) {
      onChangeErrors(errors);
    }
    if (onChangeValues && !deepEquals(prevValues, values)) {
      onChangeValues(values);
    }
    if (onChangeValidity) {
      onChangeValidity(isValid);
    }
  };

  return (
    <DynamicForm
      debugInfo={debugInfo}
      data={data}
      onChange={onChangeFormState}
      yupSchema={validationSchema}
      autoComplete="off"
      hideReqMsg={hideReqMsg}
      reqMsg={l10n('form.requiredFields')}
    />
  );
};

export default DFWrapper;
